<template>
	<div class="content">
		<div class="content__row">
			<div class="content__column content__column--wide">
				<h1 class="content__title">Carritos de Compra abiertos</h1>
			</div>
		</div>
		<div class="content__row">
			<cart-list :filters="filters"></cart-list>
			<cart-view :cart="cart" v-if="cartAction === 'view' && cart"></cart-view>
			<div class="content__column content__column--small">
				<h1 class="content__title">Opciones</h1>
				<div class="information">
					<h2 class="content__subtitle">Filtro</h2>

					<div class="form__container">
						<label for="search" class="form__label">búsqueda Libre</label>
						<input type="text" name="search" id="search" class="form__input" v-model="search" @keyup="setFilters" />
					</div>
				</div>
			</div>
		</div>
		<button @click.prevent="newCart" class="btn btn__add">Agregar</button>
	</div>
</template>

<script>
import httpService from '@/core/api/request'
import cartList from './list'
import cartView from './view'
import Mixins from './mixins'
export default {
	mixins: [httpService, Mixins],
	components: {
		cartList,
		cartView
	},
	data: function() {
		return {
			key: 0,
			search: null,
			status_id: null,
			type_id: null,
			usage_id: null,
			filters: undefined,
			cartAction: null,
			cart: null
		}
	},
	mounted: function() {
		this.$on('view', id => {
			this.getCart(id, 'view')
		})
		this.$on('edit', id => {
			this.getCart(id, 'edit')
		})
	},
	methods: {
		setFilters: function() {
			let filter = ''
			if (this.search && this.search.length > 1) {
				filter = filter + '&search=' + this.search
			}
			filter = filter.replace(/(^&+|&+$)/, '')
			if (filter.length > 0) {
				this.filters = filter
			} else {
				this.filters = undefined
			}
		},
		getCart: function(id, action) {
			this.cartAction = action
			let httpRequest = {
				params: '?embed=cart',
				module: 'shopping_carts'
			}
			this.getById(id, httpRequest).then(cart => {
				cart.data.expiration_date = new Date(cart.data.expiration_date)
				this.cart = cart.data
			})
		},
		newCart: function() {
			this.cart = undefined
			this.key = ++this.key
			this.cartAction = 'edit'
		}
	}
}
</script>

<style lang="sass">
@import "../../assets/sass/components/_home"
@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/shopping_carts/carts.vue